/* global ImagePath */

import Context from "shared/util/Context";

const placeholderImage = `${Context.get("cssImagePath")}media/img/user/placeholder_2013/pq_220.png`;

/**
 * Get an image url.
 *
 * @param {str} picid - the picture's id
 * @returns {str} - the image url
 */
const GetUrlFromPicid = (picid) => {
	if (!picid || picid === "") {
		return placeholderImage;
	}

	const resizerPath = ImagePath.resizer;
	const crop = "0x0";
	const dimensions = "800x800";
	const translations = "0";
	const fileType = "jpeg";

	return `${resizerPath}/${crop}/${dimensions}/${translations}/${picid}.${fileType}`;
};

export default GetUrlFromPicid;



// WEBPACK FOOTER //
// ./src/shared/util/GetUrlFromPicid.js